import { TInfrastructureItem } from '../../../../../types/map';

export function getTimeWalk(infrastructureItem: TInfrastructureItem): string | undefined {
  if ('timeWalk' in infrastructureItem && infrastructureItem.timeWalk) {
    return `~ ${infrastructureItem.timeWalk} мин. пешком`;
  }

  return undefined;
}
